import { useEffect, useState } from 'react';
import { useExalusServicesContext } from '../../integrations/exalus/context/services';

export const useAndroidPermissions = () => {
  const [androidLocationServiceAvailable, setAndroidLocationServiceAvailable] = useState<boolean>(false);
  const { androidLocationService } = useExalusServicesContext();

  const checkIfAndroidLocationAvailable = () => {
    const result = androidLocationService.IsAndroidLocationAvailable();
    setAndroidLocationServiceAvailable(result);
  };

  useEffect(() => {
    checkIfAndroidLocationAvailable();
  }, []);

  const getAndroidLocationPermission = async () => {
    if (androidLocationServiceAvailable) return await androidLocationService.CheckLocationPermissionAsync();
    return null;
  };

  const requestLocationPermission = async () => {
    if (androidLocationServiceAvailable) {
      return await androidLocationService.RequestLocationPermissionAsync();
    }

    return null;
  };

  return {
    getAndroidLocationPermission,
    requestLocationPermission,
  };
};
